import React, { useEffect, useState }   from 'react';
import { useDispatch, useSelector }     from 'react-redux';
import moment                           from 'moment';

import { AGENDADA }                     from '../../../../data/audienceStates';
import AuthoritiesService               from '../../../../services/AuthoritiesService';
import { Button }                       from 'react-bootstrap';
import { deleteIntermediatesAction }    from '../../../../actions/intermediatesActions';
import { ICON_NEW, ICON_REMOVE }        from '../../../extras/icons';
import IntermediateForm                 from './IntermediateForm';
import { listIntermediatesAction }      from '../../../../actions/intermediatesActions';
import { SOLICITUDES_MODIFICAR }        from '../../../../data/objects';


const IntermediatesList = props => {

    //Traigo los props
    const { audience } = props;

    //Inicializo el dispatch
    const dispatch = useDispatch();

    //Traigo el store
    const authorities = useSelector(state => state.auth.authorities);
    const intermediates = useSelector(state => state.intermediates.intermediates);

    //Inicializo el state local
    const [ show, setShow ] = useState(false);

    //Cargo al inicio los intermedios
    useEffect(() => {
        dispatch( listIntermediatesAction(audience) );
        // eslint-disable-next-line
    }, [audience]);

    //Funcion para borrar
    const handleDelete = async (intermediate) => {
        dispatch( deleteIntermediatesAction(intermediate) );      
    }
    
    //Función para ver texto
    const handleNew = () => {
        //Muestro dialógo
        setShow(true);
    }
    //Manejo el cierre
    const handleClose = () => {
        setShow(false);
    }

    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">CUARTO/S INTERMEDIO/S</h6>
                    <div className="dropdown no-arrow">
                        {   audience.estado.id===AGENDADA &&
                            authorities && 
                            AuthoritiesService.hasPermission(authorities, SOLICITUDES_MODIFICAR) &&
                                <Button 
                                    className = "float-right text-gray-400" 
                                    onClick = { handleNew }
                                    size = "sm" 
                                    variant = "light" 
                                >
                                    <ICON_NEW />
                                </Button>                            
                        }
                    </div>
                </div>
                {   intermediates?.length>0 
                        ?
                            <table className="table table-hover table-sm">
                                <thead className="thead-light">
                                    <th className="text-center">Inicio</th>
                                    <th className="text-center">Fin</th>
                                    <th className="text-center">Observacion</th>
                                    <th className="text-center">Acción</th>
                                </thead>
                                <tbody>
                                    {   intermediates.map(intermediate => intermediate.activo===1 &&
                                            <tr key={`aId${intermediate.id}`}>
                                                <td className="align-middle text-center">
                                                    { moment(intermediate.inicio).format('DD/MM/YYYY HH:mm') }
                                                </td>
                                                <td className="align-middle text-center">
                                                    { moment(intermediate.fin).format('DD/MM/YYYY HH:mm') }
                                                </td>
                                                <td className="align-middle">
                                                    { intermediate.observacion }
                                                </td>
                                                <td className="align-middle text-center">
                                                    {   audience.estado.id===AGENDADA &&
                                                        authorities && 
                                                        AuthoritiesService.hasPermission(authorities, SOLICITUDES_MODIFICAR) &&
                                                            <Button 
                                                                onClick = { ()=>handleDelete(intermediate) }
                                                                size = "sm" 
                                                                variant = "danger" 
                                                            >
                                                                <ICON_REMOVE />
                                                            </Button>
                                                    }
                                                </td>
                                            </tr>
                                    ) }
                                </tbody>
                            </table>
                    : 
                        <div className="col-12 mt-3">
                            <div className="alert alert-info">
                                No hay registros cargados.
                            </div>
                        </div>
                }
            </div>

            <IntermediateForm
                audience = { audience }
                handleClose = { handleClose }
                show = { show }
            />

        </div>
    );
};

export default IntermediatesList;